export default {
  apiUrl: "https://www-test.progrit.co.jp/",
};
